import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useRouteMatch } from "react-router-dom";
import { Alert } from "shared/Alert/Alert";
import Modal from "shared/Modal";
import { RootState } from "store";
import LinkLogo from "images/LinkLogo.svg";
import FacebookLogo from "images/FacebookLogo.svg";
import WhatsappLogo from "images/WhatsappLogo.svg";
import logging from "utils/logging";
import { eventAnalytic } from "hooks/useAnalytics";

interface LikeSaveBtn {
  liked?: boolean;
  onClick?: () => void;
}

interface IShareLocation {
  label: string;
  logo: string;
  href: (url: string) => string;
}

const ShareButtons: Array<IShareLocation> = [
  {
    label: "Link",
    logo: LinkLogo,
    href: (url: string) =>
      `https://www.facebook.com/sharer/sharer.php?u=${url}`,
  },
  {
    label: "Whatsapp",
    logo: WhatsappLogo,
    href: (url: string) => `https://api.whatsapp.com/send/?phone&text=${url}`,
  },
  {
    label: "Facebook",
    logo: FacebookLogo,
    href: (url: string) =>
      `https://www.facebook.com/dialog/share?app_id=87741124305&href=${url}&display=popup`,
  },
];

const LikeSaveBtns: React.FC<LikeSaveBtn> = ({
  liked = true,
  onClick = () => {},
}) => {
  const { userInfo } = useSelector((state: RootState) => state.userInfo);
  const [share, setShare] = useState(false);
  const [shareSucces, setShareSuccess] = useState(false);
  const route = useRouteMatch();

  const url = `https://rentrips.id${route.url}`;

  const handleOpen = () => {
    setShare(!share);
  };

  const renderShare = () => {
    return (
      <Modal open={share} handleOpen={handleOpen} title="Bagikan">
        <div className="flex gap-x-6 mb-6 dark:text-white">
          {ShareButtons.map((item, index) => {
            if (item.label === "Link") {
              return (
                <button
                  key={item.label}
                  onClick={() => {
                    navigator.clipboard.writeText(
                      `https://rentrips.id${route.url}`
                    );
                    logging(userInfo?.token || "", {
                      category: "product",
                      action: "share",
                      target: item.label,
                    });
                    eventAnalytic({
                      category: "Product",
                      action: `Share`,
                      label: item.label,
                    });
                    setShareSuccess(true);
                    setTimeout(() => {
                      setShareSuccess(false);
                    }, 2000);
                  }}
                >
                  <img
                    className="flex-shrink-0 w-20 h-20"
                    src={item.logo}
                    alt={item.label}
                  ></img>
                  <p className="mt-2"> {item.label}</p>
                </button>
              );
            }
            return (
              <a
                className="flex-col gap-y-4"
                key={item.label}
                target={"_blank"}
                rel={"noopener noreferrer"}
                href={item.href(url)}
                onClick={() => {
                  logging(userInfo?.token || "", {
                    category: "product",
                    action: "share",
                    target: item.label,
                  });
                  eventAnalytic({
                    category: "Product",
                    action: `Share`,
                    label: item.label,
                  });
                }}
              >
                <img
                  className="flex-shrink-0 w-20 h-20"
                  src={item.logo}
                  alt={item.label}
                ></img>
                <p className="mt-2"> {item.label}</p>
              </a>
            );
          })}
        </div>
        {shareSucces && <Alert type="success">Link berhasil disalin</Alert>}
      </Modal>
    );
  };
  return (
    <div className="flow-root">
      <div className="flex text-neutral-700 dark:text-neutral-300 text-sm -mx-3 -my-1.5">
        {share && renderShare()}
        <button
          className="py-1.5 px-3 flex rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 cursor-pointer"
          onClick={handleOpen}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-5 w-5"
            fill={"none"}
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-8l-4-4m0 0L8 8m4-4v12"
            />
          </svg>
          <span className="hidden sm:block ml-2.5">Bagikan</span>
        </button>
        {userInfo && (
          <button
            className="py-1.5 px-3 flex rounded-lg hover:bg-neutral-100 dark:hover:bg-neutral-800 cursor-pointer"
            onClick={onClick}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill={liked ? "red" : "none"}
              viewBox="0 0 24 24"
              stroke={liked ? "red" : "currentColor"}
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={1.5}
                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
              />
            </svg>
            <span className="hidden sm:block ml-2.5">Sukai</span>
          </button>
        )}
      </div>
    </div>
  );
};

export default LikeSaveBtns;
